import { render } from "./NavigationHierarchy.vue?vue&type=template&id=2a0f091f&scoped=true"
import script from "./NavigationHierarchy.vue?vue&type=script&lang=js"
export * from "./NavigationHierarchy.vue?vue&type=script&lang=js"

import "./NavigationHierarchy.vue?vue&type=style&index=0&id=2a0f091f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0f091f"]])

export default __exports__